import axios from "axios";

const updateGigVenueCut = async (token, tourId, gigId, venueCut) => {
  const item = { venueCut: parseInt(venueCut) };
  const path = `${process.env.REACT_APP_BACKEND_API_URL}/tours/${tourId}/gigs/${gigId}`;

  try {
    const response = await axios.put(path, item, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
    return response;
  } catch (error) {
    console.log(error.response);
    return error.response;
  }
};

export default updateGigVenueCut;